import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const ShopcategoryEdit = () => {
  const [ShopcategorytEditUser, setShopcategorytEditUser] = useState({
    discount: "",
    title: "",
  });
  const [ShopcategorytImage, setShopcategorytImage] = useState(null);
  const [ShopcategorytLogo, setShopcategorytLogo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_shop_catagory_by_id",
          { id }
        );

        // ✅ Defensive handling in case result is array or undefined
        const result = response.data?.result;
        if (Array.isArray(result) && result.length > 0) {
          setShopcategorytEditUser(result[0]);
        } else if (result && typeof result === "object") {
          setShopcategorytEditUser(result);
        } else {
          toast.error("Invalid data received from server");
        }
      } catch (error) {
        console.error("Error fetching category data!", error);
      }
    };

    fetchCategoryData();
  }, [id]);

  // ✅ Handle text inputs
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setShopcategorytEditUser({ ...ShopcategorytEditUser, [name]: value });
  };

  // ✅ Handle file changes
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === "shop_category_image") {
      setShopcategorytImage(file);
      setPreviewImage(URL.createObjectURL(file));
    } else if (type === "brand_logo") {
      setShopcategorytLogo(file);
      setPreviewLogo(URL.createObjectURL(file));
    }
  };

  // ✅ Handle form submission
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", id);
    formData.append("discount", ShopcategorytEditUser.discount);
    formData.append("title", ShopcategorytEditUser.title);

    if (ShopcategorytImage) formData.append("shop_category_image", ShopcategorytImage);
    if (ShopcategorytLogo) formData.append("brand_logo", ShopcategorytLogo);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/shop_categories_update",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data?.status === "true") {
        toast.success(response.data.message || "Category updated successfully");
        navigate("/ShopByCategory");
      } else {
        toast.error(response.data.message || "Failed to update category");
      }
    } catch (error) {
      console.error("Error updating category!", error);
    }
  };

  // ✅ Avoid rendering before data is loaded
  if (!ShopcategorytEditUser) return <p>Loading...</p>;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Edit Category</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Category</a></li>
            <li className="breadcrumb-item active">Edit</li>
          </ol>
        </div>

        <form onSubmit={submitForm}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Edit Category</h4>
            </div>
            <div className="card-body row">

              <div className="col-lg-6 mb-3">
                <label className="form-label">Main Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => handleFileChange(e, 'shop_category_image')}
                />
                {previewImage && <img src={previewImage} alt="Preview" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Brand Logo</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => handleFileChange(e, 'brand_logo')}
                />
                {previewLogo && <img src={previewLogo} alt="Logo" height="80" className="mt-2" />}
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  value={ShopcategorytEditUser.title || ""}
                  onChange={changeHandler}
                  className="form-control"
                  placeholder="Enter Title"
                />
              </div>

              <div className="col-lg-6 mb-3">
                <label className="form-label">Discount</label>
                <input
                  type="text"
                  name="discount"
                  value={ShopcategorytEditUser.discount || ""}
                  onChange={changeHandler}
                  className="form-control"
                  placeholder="e.g., 30–60% Off"
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary">
                Update Category
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShopcategoryEdit;
